import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from '../common/Header';
import { useNavigate } from 'react-router-dom';

import bannerImg1 from '../../images/sh1.png';
import bannerImg2 from '../../images/sh2.png';
import bannerImg3 from '../../images/sh3.png';

const BannerSection = () => {
    const navigate = useNavigate();

    const banners = [
        {
            image: bannerImg1,
            title: 'Woodworking Wonders\nStyled with Laminates.',
            subtitle:
                'Navkar laminates stands tall in every corner of your space, from the structural core to the finishing flair.',
            animation: { x: -50, opacity: 0 },
        },
        {
            image: bannerImg2,
            title: 'Design Beyond Limits\nCrafted to Inspire.',
            subtitle:
                'Unleashing premium laminate finishes for modern interiors and timeless impressions.',
            animation: { y: 50, opacity: 0 },
        },
        {
            image: bannerImg3,
            title: 'Elevate Spaces\nWith Elegance & Strength.',
            subtitle:
                'Where innovation meets style — explore our range of top-tier laminate solutions.',
            animation: { x: 50, opacity: 0 },
        },
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prev) => (prev + 1) % banners.length);
        }, 10000);
        return () => clearInterval(interval);
    }, [banners.length]);

    const { image, title, subtitle, animation } = banners[currentImageIndex];

    return (
        <section
            className="relative w-full h-[450px] sm:h-[600px] md:h-[650px] lg:h-[680px] bg-cover bg-center transition-all duration-1000 overflow-hidden"
            style={{ backgroundImage: `url(${image})` }}
        >
            <div className="absolute inset-0 bg-black/10 z-10"></div>

            <Header />

            <div className="relative font-Montserrat z-30 w-full max-w-[1200px] mx-auto px-4 flex flex-col items-center lg:items-start justify-center h-full pt-28 sm:pt-32">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentImageIndex}
                        initial={animation}
                        animate={{ x: 0, y: 0, opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-white text-center lg:text-left max-w-3xl"
                    >
                        <p className="text-3xl whitespace-pre-line sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-normal mb-4 sm:mb-6">
                            {title}
                        </p>
                        <p className="text-sm sm:text-base md:text-lg mb-6 sm:mb-8">
                            {subtitle}
                        </p>
                        <button
                            className="bg-[#92400e] text-white px-6 py-3 rounded-md text-sm sm:text-base hover:bg-[#773109] transition"
                            onClick={() => navigate('/about')}
                        >
                            Know Us
                        </button>
                    </motion.div>
                </AnimatePresence>
            </div>
        </section>
    );
};

export default BannerSection;
